import z from 'zod'

import { ENDPOINT } from '@/config/endpoint'
import { apiFactory, apiOk } from '@/libs/api'

import * as dto from '../schema/product-schema'

export const productApi = {
  list: apiFactory({
    url: ENDPOINT.product.master.list,
    method: 'get',
    schema: {
      params: z.custom<{ outletId: string }>(),
      result: apiOk(z.object({ products: dto.ProductSelectDto.array() })),
    },
  }),
  detail: apiFactory({
    url: ENDPOINT.product.master.detail,
    method: 'get',
    schema: {
      params: z.custom<{ id: string }>(),
      result: apiOk(z.object({ product: dto.ProductSelectDto })),
    },
  }),
  create: apiFactory({
    url: ENDPOINT.product.master.create,
    method: 'post',
    schema: {
      body: z.custom<dto.ProductCreateBodyDto>(),
      result: apiOk(z.unknown()),
    },
  }),
  update: apiFactory({
    url: ENDPOINT.product.master.update,
    method: 'put',
    schema: {
      body: z.custom<dto.ProductCreateBodyDto & { id: string }>(),
      result: apiOk(z.unknown()),
    },
  }),
}
